import { Controller } from "@hotwired/stimulus"

// Agenda de la landing Markets Experience: pestañas por sala que muestran
// solo los slots de la sala seleccionada. Por defecto se muestra la primera.
export default class extends Controller {
  static targets = ["tab", "sala"]

  connect() {
    this.select(0)
  }

  filter(event) {
    this.select(Number(event.currentTarget.dataset.sala))
  }

  select(index) {
    this.tabTargets.forEach((tab) => {
      tab.setAttribute("aria-selected", Number(tab.dataset.sala) === index)
    })
    this.salaTargets.forEach((sala) => {
      sala.toggleAttribute("hidden", Number(sala.dataset.sala) !== index)
    })
  }
}
